import { createRpcTransport } from "./kernel-connector.js";
export const KERNEL_WAKE_MESSAGE = "\u0000node-client:kernel-wake";
export class SharedWorkerKernelHost {
    #createWorker;
    #name;
    constructor(options) {
        this.#createWorker = options.createWorker;
        this.#name = options.name;
    }
    connect() {
        const worker = this.#createWorker(this.#name);
        worker.port.start();
        return createRpcTransport(worker.port);
    }
    wake() {
        const worker = this.#createWorker(this.#name);
        worker.port.start();
        worker.port.postMessage(KERNEL_WAKE_MESSAGE);
        worker.port.close();
    }
}
//# sourceMappingURL=shared-worker-host.js.map